export default __webpack_public_path__ + "static/media/cypress.76c5258b.svg";